module.exports = __webpack_public_path__ + "img/jyl-zc.cbd7c1e6.png";